import { SCHEDULER } from '../../../../utils/ServiceUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface ITaskTemplateListRequest extends IBaseRequest {
    limit?: number;
    type?: string;
    offset?: number;
}

export class TaskTemplateListRequest extends BaseRequest implements ITaskTemplateListRequest {
    public limit?: number;
    public type?: string;
    public offset?: number;

    constructor(server: string, session: string, limit?: number, type?: string, offset?: number) {
        super(server, session);
        this.limit = limit;
        this.type = type;
        this.offset = offset;
    }

    public toXml(): string {
        let parameters: string = super.toXml();

        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.type, 'type');
        parameters += this.makeNode(this.offset, 'offset');

        return super.wrapperXml(SCHEDULER.taskTemplateList, parameters);
    }
}
